import React, { useMemo } from 'react'
import CustomButton from '../customButton/ui/main/CustomButton'
import { languageNames } from '../../../constants/languages'
import Icon from '../../baseComponents/gui/icon/Icon'
import { safeHTML } from '../../../utils/safeHTML'
import classNames from 'classnames'
import { useLanguageControls } from '../../../hooks/useLanguageControls'
import { useModal } from '../../../hooks/useModal'
import { useTranslation } from '../../../translations'

const SelectLangButton = React.forwardRef(function SelectLangButton(
  { text, className, callbacks, isIcon, isBg },
  ref,
) {
  const { language } = useLanguageControls()
  const { addModal } = useModal()
  const { t } = useTranslation()

  const openLangModal = () => {
    addModal({
      type: 'selectLangModal',
      props: {
        title: t('selectLangModalContent.title'),
        description: t('selectLangModalContent.description'),
      },
    })
  }

  const handleClick = (event) => {
    event.stopPropagation()
    openLangModal()
  }

  const buttontText = useMemo(() => {
    if (text) {
      return `${text}:&nbsp;`
    }
    return null
  }, [text])

  return (
    <CustomButton
      callbacks={callbacks}
      className={classNames(
        `select-lang-button button_select-lang-button ${
          isBg ? 'select-lang-button_bg_active' : ''
        }`,
        className,
      )}
      onClick={handleClick}
      icon={isIcon ? 'buttons/select-lang-icon' : null}
    >
      {safeHTML(buttontText)}

      <span className={`button__text custom-button__text`}>
        {languageNames[language]}
        <Icon
          name='buttons/chevron-right'
          className='custom-button__icon select-lang-button__icon select-lang-button__icon_chevron'
        />
      </span>
    </CustomButton>
  )
})

export default SelectLangButton
SelectLangButton.propTypes = {}
